<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        sm="8"
      >
        <v-subheader>Estadísticas</v-subheader>
      </v-col>
      <v-col
        cols="12"
        sm="4"
      >
        <v-select
          v-model="report_option"
          :items="evaluations"
          item-text="name"
          item-value="value"
          label="Seleccione evaluación"
        />
      </v-col>
      <v-col cols="12">
        <base-material-card
          icon="mdi-timeline-clock-outline"
          title="Rendimiento Episodio 1"
          class="px-5 py-3"
        >
          <v-data-table
            :headers="headersTable1"
            :items="dataTable1"
            :hide-default-footer="true"
          />
        </base-material-card>
      </v-col>
      <v-col cols="12">
        <v-divider class="ma-2" />
      </v-col>
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          v-for="(c , i) in 8"
          :key="i"
          cols="3"
          sm="1"
        >
          <v-btn
            small
            outlined
            color="primary"
            @click="changeLevel(`Nivel ${i + 1 }`, i + 1)"
          >
            Nivel {{ i + 1 }}
          </v-btn>
        </v-col>
      </v-row>
      <v-col cols="12">
        <base-material-card
          icon="mdi-playlist-check"
          :title="levelSelected"
          class="px-5 py-3"
        >
          <v-data-table
            :headers="headersTable3"
            :items="dataTable3"
            :hide-default-footer="true"
          />
          <v-data-table
            :headers="headersTable2"
            :items="dataTable2"
          />
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    data () {
      return {
        n: 1,
        report_option: 0,
        evaluations: [
          { name: 'Evaluación #1', value: 0 },
          { name: 'Evaluación #2', value: 1 },
        ],
        quizzes: [],
        level: '0101',
        levelSelected: 'Nivel 1',
        answersTotal: 0,
        answersTotalCorrect: 0,
        headersTable1: [
          {
            text: '',
            align: 'start',
            value: 'category',
            sortable: false,
          },
          { text: 'Total repuestas', value: 'totalAnswers', align: 'center', sortable: false },
          { text: 'Total repuestas correctas', value: 'totalAnswersCorrect', align: 'center', sortable: false },
          { text: '%', value: 'percentage', align: 'center', sortable: false },
          { text: 'Tiempo prom. respuesta (seg.)', value: 'avgTimeAnswers', align: 'center', sortable: false },
          { text: 'Tiempo prom. lectura por cuadro texto (seg.)', value: 'avgStoryTime', align: 'center', sortable: false },
        ],
        dataTable1: [
          {
            category: 'Rendimiento Episodio 1',
            totalAnswers: 0,
            totalAnswersCorrect: 0,
            percentage: 0,
            avgTimeAnswers: 0,
            avgStoryTime: 0,
          },
        ],
        headersTable3: [
          {
            text: '',
            align: 'center',
            value: 'category',
            sortable: false,
          },
          { text: 'Total repuestas', value: 'totalAnswers', align: 'center', sortable: false },
          { text: 'Total repuestas correctas', value: 'totalAnswersCorrect', align: 'center', sortable: false },
          { text: '%', value: 'percentage', align: 'center', sortable: false },
          { text: 'Tiempo prom. respuesta (seg.)', value: 'avgTimeAnswers', align: 'center', sortable: false },
          { text: 'Tiempo prom. lectura por cuadro texto (seg.)', value: 'avgTimeReadBoxText', align: 'center', sortable: false },
        ],
        dataTable3: [
          {
            category: 'Total',
            totalAnswers: 0,
            totalAnswersCorrect: 0,
            percentage: 0,
            avgTimeAnswers: 0,
            avgTimeReadBoxText: 0,
          },
        ],
        headersTable2: [
          {
            text: '# Pregunta',
            align: 'center',
            value: 'category',
            sortable: false,
          },
          { text: 'Total repuestas', value: 'totalAnswers', align: 'center', sortable: false },
          { text: 'Total repuestas correctas', value: 'totalAnswersCorrect', align: 'center', sortable: false },
          { text: '%', value: 'percentage', align: 'center', sortable: false },
          /* { text: 'Tiempo prom. respuesta (seg.)', value: 'avgTimeAnswers', align: 'center', sortable: false },
          { text: 'Tiempo prom. lectura por cuadro texto (seg.)', value: 'avgTimeReadBoxText', align: 'center', sortable: false }, */
        ],
        dataTable2: [
          {
            category: '1',
            totalAnswers: 0,
            totalAnswersCorrect: 0,
            percentage: 0,
            avgTimeAnswers: 0,
            avgTimeReadBoxText: 0,
          },
          {
            category: '2',
            totalAnswers: 0,
            totalAnswersCorrect: 0,
            percentage: 0,
            avgTimeAnswers: 0,
            avgTimeReadBoxText: 0,
          },
          {
            category: '3',
            totalAnswers: 0,
            totalAnswersCorrect: 0,
            percentage: 0,
            avgTimeAnswers: 0,
            avgTimeReadBoxText: 0,
          },
          {
            category: '4',
            totalAnswers: 0,
            totalAnswersCorrect: 0,
            percentage: 0,
            avgTimeAnswers: 0,
            avgTimeReadBoxText: 0,
          },
          {
            category: '5',
            totalAnswers: 0,
            totalAnswersCorrect: 0,
            percentage: 0,
            avgTimeAnswers: 0,
            avgTimeReadBoxText: 0,
          },
          {
            category: '6',
            totalAnswers: 0,
            totalAnswersCorrect: 0,
            percentage: 0,
            avgTimeAnswers: 0,
            avgTimeReadBoxText: 0,
          },
          {
            category: '7',
            totalAnswers: 0,
            totalAnswersCorrect: 0,
            percentage: 0,
            avgTimeAnswers: 0,
            avgTimeReadBoxText: 0,
          },
          {
            category: '8',
            totalAnswers: 0,
            totalAnswersCorrect: 0,
            percentage: 0,
            avgTimeAnswers: 0,
            avgTimeReadBoxText: 0,
          },
          {
            category: '9',
            totalAnswers: 0,
            totalAnswersCorrect: 0,
            percentage: 0,
            avgTimeAnswers: 0,
            avgTimeReadBoxText: 0,
          },
          {
            category: '10',
            totalAnswers: 0,
            totalAnswersCorrect: 0,
            percentage: 0,
            avgTimeAnswers: 0,
            avgTimeReadBoxText: 0,
          },
          {
            category: '11',
            totalAnswers: 0,
            totalAnswersCorrect: 0,
            percentage: 0,
            avgTimeAnswers: 0,
            avgTimeReadBoxText: 0,
          },
          {
            category: '12',
            totalAnswers: 0,
            totalAnswersCorrect: 0,
            percentage: 0,
            avgTimeAnswers: 0,
            avgTimeReadBoxText: 0,
          },
          {
            category: '13',
            totalAnswers: 0,
            totalAnswersCorrect: 0,
            percentage: 0,
            avgTimeAnswers: 0,
            avgTimeReadBoxText: 0,
          },
          {
            category: '14',
            totalAnswers: 0,
            totalAnswersCorrect: 0,
            percentage: 0,
            avgTimeAnswers: 0,
            avgTimeReadBoxText: 0,
          },
          {
            category: '15',
            totalAnswers: 0,
            totalAnswersCorrect: 0,
            percentage: 0,
            avgTimeAnswers: 0,
            avgTimeReadBoxText: 0,
          },
          {
            category: '16',
            totalAnswers: 0,
            totalAnswersCorrect: 0,
            percentage: 0,
            avgTimeAnswers: 0,
            avgTimeReadBoxText: 0,
          },
          {
            category: '17',
            totalAnswers: 0,
            totalAnswersCorrect: 0,
            percentage: 0,
            avgTimeAnswers: 0,
            avgTimeReadBoxText: 0,
          },
          {
            category: '18',
            totalAnswers: 0,
            totalAnswersCorrect: 0,
            percentage: 0,
            avgTimeAnswers: 0,
            avgTimeReadBoxText: 0,
          },
          {
            category: '19',
            totalAnswers: 0,
            totalAnswersCorrect: 0,
            percentage: 0,
            avgTimeAnswers: 0,
            avgTimeReadBoxText: 0,
          },
          {
            category: '20',
            totalAnswers: 0,
            totalAnswersCorrect: 0,
            percentage: 0,
            avgTimeAnswers: 0,
            avgTimeReadBoxText: 0,
          },
        ],
      }
    },
    computed: {
      ...mapState(['dataUserAdmin']),
    },
    watch: {
      dataUserAdmin (val) {
        this.processData(val)
        this.quizzes = val
        this.processDataLevel(1)
      },
      report_option (value) {
        this.processData(this.quizzes)
        this.processDataLevel(this.n)
      },
    },
    async mounted () {
      await this.init()
    },
    methods: {
      processData (quizzes) {
        let solveTime = 0
        let solveTimeTotal = 0
        this.answersTotal = 0
        this.answersTotalCorrect = 0
        this.avgTimeAnswers = 0
        let countSolveTime = 0
        let storyTime = 0
        let storyTimeTotal = 0
        this.avgStoryTime = 0
        quizzes.forEach(quiz => {
          for (let index = 1; index <= 8; index++) {
            const level = quiz.levels[`010${index}`]

            if (level) {
              if (level[this.report_option]) {
                const q = level[this.report_option]
                this.answersTotalCorrect += q.answers.split('2').length - 1
                this.answersTotal += q.answers.split('1').length - 1
                // console.log(this.answersTotalCorrect, q.answers.split('2').length - 1)
                // console.log(this.answersTotal, q.answers.split('1').length - 1)
                this.answersTotal += this.answersTotalCorrect
                this.dataTable1[0].totalAnswers = this.answersTotal
                this.dataTable1[0].totalAnswersCorrect = this.answersTotalCorrect
                this.dataTable1[0].percentage = (this.answersTotalCorrect / this.answersTotal * 100).toFixed(2)

                solveTime = quiz.levelsSolveTime ? parseFloat(quiz.levelsSolveTime) : 0
                if (solveTime > 0) {
                  countSolveTime++
                  solveTime /= 20
                  solveTimeTotal += solveTime
                  this.avgTimeAnswers = solveTimeTotal
                  this.dataTable1[0].avgTimeAnswers = (this.avgTimeAnswers / countSolveTime).toFixed(2)
                }
                storyTime = quiz.levelsStoryTime ? parseFloat(quiz.levelsStoryTime) : 0
                if (storyTime > 0) {
                  storyTimeTotal += storyTime
                  this.avgStoryTime += storyTimeTotal
                  this.avgStoryTime /= this.answersTotal
                  this.dataTable1[0].avgStoryTime = this.avgStoryTime.toFixed(2)
                }
              }
            }
          }
        })
      },
      changeLevel (level, n) {
        this.levelSelected = level
        this.n = n
        this.processDataLevel(n)
      },
      processDataLevel (n) {
        for (let question = 0; question < 20; question++) {
          this.dataTable2[question].totalAnswers = 0
          this.dataTable2[question].totalAnswersCorrect = 0
          this.dataTable2[question].percentage = 0
        }
        this.dataTable3[0].totalAnswers = 0
        this.dataTable3[0].totalAnswersCorrect = 0
        this.dataTable3[0].percentage = 0

        this.level = `010${n}`
        // let totalAnswers = 0
        // let totalAnswersCorrect = 0
        // let totalAnswersQuestion = 0
        // let totalAnswersCorrectQuestion = 0
        let countLevelsSolveTime = 0
        let solveTime = 0
        let solveTimeTotal = 0
        let storyTimeTotal = 0
        this.quizzes.forEach(quiz => {
          const level = quiz.levels[this.level]
          if (level) {
            if (level[this.report_option]) {
              solveTime = level[this.report_option].solve_time ? parseFloat(level[this.report_option].solve_time) : 0
              if (solveTime > 0) {
                countLevelsSolveTime++
                solveTimeTotal += solveTime / 20
                this.dataTable3[0].avgTimeAnswers = (solveTimeTotal / countLevelsSolveTime).toFixed(2)
              }
              const storyTime = level[this.report_option].story_time ? parseFloat(level[this.report_option].story_time) : 0
              const textCount = level[this.report_option].story_time ? parseFloat(level[this.report_option].text_count) : 0
              if (textCount > 0 && storyTime > 0) {
                storyTimeTotal += storyTime / textCount
                this.dataTable3[0].avgTimeReadBoxText = storyTimeTotal.toFixed(2)
              }
              const q = level[this.report_option]
              for (let question = 0; question < 20; question++) {
                if (q.answers.substring(question, (question + 1)) !== '0') {
                  // totalAnswersQuestion = this.dataTable2[question].totalAnswers++
                  this.dataTable2[question].totalAnswers++
                  // totalAnswers = this.dataTable3[0].totalAnswers++
                  this.dataTable3[0].totalAnswers++

                  if (q.answers.substring(question, (question + 1)) === '2') {
                    // totalAnswersCorrectQuestion = this.dataTable2[question].totalAnswersCorrect++
                    // totalAnswersCorrect = this.dataTable3[0].totalAnswersCorrect++
                    this.dataTable2[question].totalAnswersCorrect++
                    this.dataTable3[0].totalAnswersCorrect++
                  }
                }
                this.dataTable3[0].percentage = (this.dataTable3[0].totalAnswersCorrect / this.dataTable3[0].totalAnswers * 100).toFixed(2)

                this.dataTable2[question].percentage = (this.dataTable2[question].totalAnswersCorrect / this.dataTable2[question].totalAnswers * 100).toFixed(2)
              }
            }
          }
        })
      },
      async init () {
        await this.$store.dispatch('GET_ADMIN_DATA')
      },
    },
    beforeRouteEnter (to, from, next) {
      next(async vm => {
        const userData = await vm.$store.dispatch('GET_USER_DATA')
        if (userData.type === 'admin') {
          vm.viewPage = true
          next()
        } else {
          console.log('Está intentando ingresar a una pagina no autorizada.')
          next({
            name: 'Home',
          })
        }
      })
    },
  }
</script>
